export enum EnumClaimRequestStatus {
  DRAFT = "DRAFT",
  WAITING = "WAITING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELED = "CANCELED",
}
